import React from "react";
import Button from "../Button";
import Wrapper from "../../../_hoc/Wrapper";
const FilterWidget = ({ show, onToggle, onSearch, children }) => {
  return (
    <Wrapper>
      {show ? children : null}
      <div className="row">
        <div className="col-sm-12">
          <Button
            label="Search"
            className="pull-right"
            style={{ marginLeft: "10px" }}
            success
            small
            onClick={onSearch}
          />
          <Button
            label={show ? "Hide Filter" : "Modify Search"}
            className="pull-right"
            primary
            small
            onClick={onToggle}
          />
        </div>
      </div>
    </Wrapper>
  );
};

export default FilterWidget;



// WEBPACK FOOTER //
// ./src/_components/UI/FilterWidget/index.js